import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "text-9xl font-semibold text-[#36a8dd]" }
const _hoisted_4 = { class: "mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl" }
const _hoisted_5 = { class: "mt-6 text-base leading-7 text-gray-600" }
const _hoisted_6 = { class: "text-base leading-7 text-gray-600" }
const _hoisted_7 = { class: "mt-10 flex items-center justify-center gap-x-6" }




export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorRefreshPage',
  props: ['message', 'statusCode'],
  setup(__props) {

const props = __props
const messages = [
    "Sorry, something went wrong",
    "Try refresh the page or try again in a moment"
]

function refresh() {
    location.reload()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(props.statusCode), 1),
      _createElementVNode("h1", _hoisted_4, _toDisplayString(props.message), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(messages[0]), 1),
      _createElementVNode("p", _hoisted_6, _toDisplayString(messages[1]), 1),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => {refresh();}),
          class: "rounded-md bg-[#36a8dd] px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-[#36a8dd] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#36a8dd]"
        }, "Refresh")
      ])
    ])
  ]))
}
}

})